import { Translate } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { AnalyticsTrigger, Button, Heading, Notice, Text } from 'telia-front-react';
import Config from '../Config';

export interface TradeInSuccessModalProps {
  translate: Translate;
  [key: string]: any;
}

const TradeInSuccessContent: FC<TradeInSuccessModalProps> = ({ translate, ...rest }) => {
  return (
    <Notice type="success" direction="vertical">
      <Text className="text-center">
        <Heading element="h1" id="added-modal-title" className="h4 text-bold">
          {translate('tradeIn.successModal.heading', rest)}
        </Heading>
        <p className="h5">{translate('tradeIn.successModal.info', rest)}</p>
        <p className="text__margin-double">
          <AnalyticsTrigger trigger={{ id: 'Link - Suundun e-poodi', callback: 'onClick' }}>
            <Button
              id="enter-shop-button"
              url={`${Config.teliaShopUrl}/${rest['category']}`}
              text={`${translate('tradeIn.successModal.close')}`}
              iconRight="#arrow-right"
            />
          </AnalyticsTrigger>
        </p>
      </Text>
    </Notice>
  );
};

export default observer(TradeInSuccessContent);
